<template>
  <div>
    <v-dialog v-model="showDialog" :width="950">
      <v-container column>
        <v-card color="#0d2340" class="pa-0" :height="600">
          <v-card-text class="pt-5 relative-position">
            <div class="close-icon-container">
              <v-icon
                color="#CDDB00"
                size="18"
                @click="showDialog = false"
                class="cursor-pointer"
                title="Close"
                >fas fa-times</v-icon
              >
            </div>
            <div class="text-container">
              <div class="relative-position">
                <p>
                  <span class="highlighted-text application-heading"
                    >We're now Seerist!</span
                  >
                </p>
                <p class="text-main">
                  Geospark Analytics' Hyperion and Control Risks' CORE platforms
                  have joined forces to create Seerist.
                </p>
                <p class="text-main">
                  Seerist is the only augmented analytics solution for threat
                  and risk intelligence professionals. It combines adaptive
                  artificial intelligence with localized geopolitical risk
                  expertise to sift through the noise of global chatter,
                  forecast potential threats, and offer insights enabling rapid,
                  reliable decision making when it matters most.
                </p>
                <p class="text-main">
                  So you can
                  <span class="application-heading">act today</span> and
                  <span class="application-heading">prevail tomorrow</span> -
                  saving lives, assets, resources and time.
                </p>

                <hr class="my-5 hr-light" />

                <p class="text-main">
                  Go to
                  <a
                    href="https://www.seerist.com"
                    target="_blank"
                    class="link-text"
                    >seerist.com</a
                  >
                  and read the
                  <a
                    href="https://seerist.com/press-releases/seerist_launches/"
                    target="_blank"
                    class="link-text"
                    >press release</a
                  >.
                </p>
                <p class="text-main">Download the Seerist mobile app.</p>
                <p>
                  <a
                    href="https://apps.apple.com/us/app/hyperion-mobile/id1501289995"
                    target="_blank"
                    ><img :src="downloadAppleSrc" class="mr-4" width="100"
                  /></a>
                  <a
                    href="https://play.google.com/store/apps/details?id=io.geospark.hyperion"
                    target="_blank"
                    ><img :src="downloadAndroidSrc" width="100"
                  /></a>
                </p>

                <div>
                  <a
                    href="https://www.linkedin.com/company/seeristinc"
                    target="_blank"
                    ><img :src="linkedInSrc" class="mr-2" width="30"
                  /></a>
                  <a href="https://twitter.com/seeristinc" target="_blank"
                    ><img :src="twitterSrc" width="30"
                  /></a>
                </div>

                <div class="accepted-container">
                  <v-checkbox
                    v-model="accepted"
                    label="Don't show this popup again"
                    hide-details
                    color="white"
                    class="shrink mt-0 mr-3 pull-right accept-checkbox"
                    @click="acceptWelcome"
                  ></v-checkbox>
                  <Loader
                    v-if="processing"
                    color="secondary"
                    size="small"
                    text=""
                    class="pull-right mr-2 loader-icon"
                  ></Loader>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
            <img :src="imgSrc" width="400px" class="logo" />
          </v-card-text>
        </v-card>
      </v-container>
    </v-dialog>
  </div>
</template>

<script>
import { acceptWelcomeMessage } from "@/services/user/user.service";
import { hasGroupByName } from "@/services/user/user.service";

export default {
  name: "WelcomeMessage",
  components: {
    Loader: () => import("@/components/common/Loader"),
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    accepted: false,
    processing: false,
    showDialog: false,
  }),
  mounted() {
    this.checkIfShow();
  },
  computed: {
    imgSrc() {
      return require("@/assets/images/seerist_logo_large.png");
    },
    downloadAppleSrc() {
      return require("@/assets/images/download_apple.png");
    },
    downloadAndroidSrc() {
      return require("@/assets/images/download_android.png");
    },
    linkedInSrc() {
      return require("@/assets/images/linkedin_logo.png");
    },
    twitterSrc() {
      return require("@/assets/images/twitter_logo.png");
    },
  },
  methods: {
    checkIfShow() {
      if (
        this.featureUnlocked("welcome-message") &&
        !hasGroupByName("Accepted_Welcome_Message")
      ) {
        this.showDialog = true;
      }
    },
    async acceptWelcome() {
      if (!this.accepted) {
        return false;
      }
      this.processing = true;
      await acceptWelcomeMessage();
      this.showDialog = false;
      this.processing = false;
    },
  },
};
</script>

<style lang="scss">
.accept-checkbox .v-label {
  font-size: 14px !important;
  color: $secondary-color !important;
}
.accept-checkbox .v-icon {
  color: $secondary-color !important;
}
</style>

<style scoped lang="scss">
.close-icon-container {
  position: absolute;
  right: 40px;
  top: 30px;
  z-index: 2;
}
.text-container {
  position: absolute;
  left: 450px;
  top: 30px;
  width: 450px;
  background-color: transparent;
}
.highlighted-text {
  color: $primary-color;
  font-size: 28px;
  line-height: 34px;
}
.text-main {
  color: white;
  font-size: 16px;
  line-height: 24px;
}
.hr-light {
  border-top: none;
  border-bottom: 1px solid #cddb00;
}
.logo {
  margin-top: 80px;
}
.loader-icon {
  position: relative;
  top: 3px;
}
.accepted-container {
  position: relative;
  top: -30px;
  right: -200px;
  width: 250px;
}
.link-text {
  color: $secondary-color !important;
}
</style>
